import React, { useCallback, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faPlus, faQrcode } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import QRCodeGenerator from '../../components/QRCodeGenerator';
import DonaQRCodeGenerator from './DonaQRCodeGenerator';
import './DonaQR.css';


const DonaQRMyQRs = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [donaQRs, setDonaQRs] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedDonaQRId, setSelectedDonaQRId] = useState(null);

  const [qrData, setQrData] = useState('');
  const [showQRCode, setShowQRCode] = useState(false);

  // const history = useHistory();


  const fetchDonaQRs = useCallback(() => {
    const config = { url: "/donaqrs", method: "get", headers: { Authorization: authState.token } };
    fetchData(config, { showSuccessToast: false })
      .then(data => {
        // console.log("Response:", data); // Log the entire response object
        setDonaQRs(data);
      })
      .catch(error => console.error("Error fetching DonaQRs:", error));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchDonaQRs();
  }, [authState.isLoggedIn, fetchDonaQRs]);

  useEffect(() => {
    if (donaQRs && donaQRs.donaQRText) {
      setQrData(donaQRs.donaQRText);
    }
  }, [donaQRs]);


  if (loading) {
    return <Loader />;
  }

  const handleView = (donaQRId) => {
    setSelectedDonaQRId(prevId => (prevId === donaQRId ? null : donaQRId));
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleRefresh = () => {
    fetchDonaQRs();
  };


  const caesarCipher = (text, key) => {
    let result = '';
    for (let i = 0; i < text.length; i++) {
      let charCode = text.charCodeAt(i);
      if (charCode >= 65 && charCode <= 90) {
        result += String.fromCharCode(((charCode - 65 + key) % 26) + 65);
      } else if (charCode >= 97 && charCode <= 122) {
        result += String.fromCharCode(((charCode - 97 + key) % 26) + 97);
      } else {
        result += text.charAt(i);
      }
    }
    return result;
  };


  const handleGenerateQRCode = (donaQRText) => {
    setShowQRCode(!showQRCode);
  };


  // const { donaQR } = props;
  const calculateTotalAmount = (donaqrDonors) => {
    let totalAmount = 0;
    donaqrDonors.forEach(donor => {
      totalAmount += donor.donationAmount;
    });
    return totalAmount.toFixed(2);
  };

  return (
    <div className="my-2 mx-auto max-w-[700px] py-4">
      {/* {loading ? <Loader /> : (
        <> */}
      {donaQRs.length !== 0 && (
        <div className="search-container">
          {/* Search inputs */}
        </div>
      )}

      <div className="list-container border border-gray-300 p-4 mt-4">
        {/* DonaQR list */}
        <div className="flex justify-between items-center mt-2">
          <div className='w-full h-full px-1 py-2 ml-1 mr-4 flex items-center'>
            <Tooltip text={"Refresh Data"} position={"top"}>
              <FontAwesomeIcon icon={faDatabase} className="cursor-pointer text-white mr-2" onClick={handleRefresh} />
            </Tooltip>
            {donaQRs.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-white'>Your QR Codes ({donaQRs.length})</h2>}
            {donaQRs.length === 0 && <h2 className='my-2 ml-2 md:ml-0 text-white'>Your QR Codes</h2>}
          </div>
          <div className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md w-full">
            <Link to='/donaqrs/add' className='block w-full h-full px-1 py-2 ml-4 mr-4'>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '10px' }} />  Get New QR Code
            </Link>
          </div>
        </div>

        {donaQRs.length === 0 ? (
          <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
            <span>No record found</span>
          </div>
        ) : (
          <div>
            {donaQRs.map((donaQR, index) => (
              <div key={donaQR._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium'>{index + 1}. {donaQR.donaqrTitle}</span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(donaQR._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"View QR"} position={"top"}>
                    <span className='ml-0 mr-1 text-blue-500 cursor-pointer' onClick={() => handleGenerateQRCode(donaQR.donaQRText)}>
                      <i className="fa-solid fa-qrcode"></i>
                    </span>
                  </Tooltip>
                </div>
                <div className='mt-4'>
                  <p className={donaQR.donaqrIsActive ? 'text-green' : 'text-red'}>
                    <strong>{donaQR.donaqrIsActive ? 'The Code Is Active' : 'The Code IS Inactive'}</strong>
                  </p>
                  <div className='centered-content"'>
                    {/* {donaQR.donaqrIsActive ? 'text-green' : 'text-red'} */}
                    {showQRCode && !donaQR.donaqrIsEncrypted && <DonaQRCodeGenerator data={donaQR.donaQRText} />}
                    {showQRCode && donaQR.donaqrIsEncrypted && <DonaQRCodeGenerator data={caesarCipher(donaQR.donaQRText, donaQR.donaqrEncryptionKey)} />}
                  </div>
                </div>
                {selectedDonaQRId === donaQR._id && (
                  <div className='bg-gray-200 text-black'>
                    <h2 className='text-blue-600'><strong>My DonaQR One-View for {donaQR.donaqrTitle}</strong></h2>
                    <p><strong>Owner Name:</strong> {donaQR.donaqrOwnerName}</p>
                    <br />
                    <p><strong>Current Balance:</strong> {donaQR.donaqrCurrentBalance}</p>
                    <p><strong>Recharge History:</strong></p>
                    {Array.isArray(donaQR.donaqrRechargeHistory) && donaQR.donaqrRechargeHistory.map((rechargehistory, index) => (
                      <div className="ml-8 text-blue-800">
                        <p><strong>Date:</strong> {rechargehistory.rechargeDate}</p>
                        <p><strong>Amount:</strong> {rechargehistory.rechargeAmount}</p>
                        <p><strong>Currency:</strong> {rechargehistory.rechargeCurrency}</p>
                        <p><strong>Remarks:</strong> {rechargehistory.rechargeRemarks}</p>
                        <p><strong>Receipt Number:</strong> {rechargehistory.rechargeReceiptNumber}</p>
                      </div>
                    ))}
                    <br />
                    <p><strong>Title:</strong> {donaQR.donaqrTitle}</p>
                    <p><strong>Is a Campaign:</strong> {donaQR.donaqrIsCampaign ? 'Yes' : 'No'}</p>
                    <p><strong>Purpose:</strong> {donaQR.donaqrPurpose}</p>
                    <p><strong>Beneficiary Name:</strong> {donaQR.donaqrBen}</p>
                    <p><strong>Beneficiary Contact Details:</strong> {donaQR.donaqrBenAddress}</p>
                    <p><strong>Month & Year:</strong> {donaQR.donaqrMonthYear}</p>
                    <p><strong>Start Date:</strong> {donaQR.donaqrStartDate}</p>
                    <p><strong>Has End Date?:</strong> {donaQR.donaqrHasEndDate ? 'Yes' : 'No'}</p>
                    <p><strong>EndDate:</strong> {donaQR.donaqrEndDate}</p>
                    <p><strong>Campaign Days:</strong> {donaQR.donaqrCampaignDays}</p>
                    <p><strong>Target Amount:</strong> {donaQR.donaqrTargetAmount}</p>
                    {/* <p><strong>Has Banner?:</strong> {donaQR.donaqrHasBanner}</p>
                    <p><strong>Banner File Name:</strong> {donaQR.donaqrBannerFileName}</p>
                    <p><strong>Banner Path Name:</strong> {donaQR.donaqrBannerPathName}</p> */}
                    <p><strong>PAN Details:</strong> {donaQR.donaqrPANDetails}</p>
                    <p><strong>Bank Details:</strong> {donaQR.donaqrBankDetails}</p>
                    <br />
                    <p><strong>Show Income/Expenditure:</strong> {donaQR.donaqrShowAccounting ? 'Yes' : 'No'}</p>
                    <p><strong>Income/Expenditure:</strong></p>
                    {Array.isArray(donaQR.donaqrAccounting) && (
                      <table className="table-auto w-full">
                        <thead className="bg-gray-500">
                          <tr>
                            <th className="px-2 py-0 text-left">Group</th>
                            <th className="px-2 py-0 text-left">Head</th>
                            <th className="px-2 py-0 text-left">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {donaQR.donaqrAccounting.map((item, index) => (
                            <tr key={index} className="text-blue-800">
                              <td className="border px-2 py-0 text-left">{item.group}</td>
                              <td className="border px-2 py-0 text-left">{item.head}</td>
                              <td className="border px-2 py-0 text-left">{item.amount.toFixed(2)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                    <p><strong>Auditor Name:</strong> {donaQR.donaqrAuditorName}</p>
                    <br />
                    <p><strong>Verification:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Is Verified:</strong> {donaQR.donaqrIsVerified ? 'Yes' : 'No'}</p>
                      <p><strong>Verification Date:</strong> {donaQR.donaqrVerificationDate}</p>
                      <p><strong>Verifier Name:</strong> {donaQR.donaqrVerifierName}</p>
                      <p><strong>Verified Date:</strong> {donaQR.donaqrVerifiedDate}</p>
                    </div>
                    <br />
                    {/* <p><strong>Is Active:</strong> {donaQR.donaqrIsActive ? 'Yes' : 'No'}</p>
                    <p><strong>Is Deleted:</strong> {donaQR.donaqrIsDeleted ? 'Yes' : 'No'}</p> */}
                    <p><strong>Date Created:</strong> {donaQR.donaqrDateCreated}</p>
                    <br />
                    <p><strong>Is Encrypted:</strong> {donaQR.donaqrIsEncrypted ? 'Yes' : 'No'}</p>
                    <p><strong>Encryption Key:</strong> {donaQR.donaqrEncryptionKey}</p>
                    <p><strong>QR Text:</strong> {donaQR.donaQRText}</p>
                    {donaQR.donaqrIsEncrypted && (
                      <p className='text-yellow-600'>
                        <strong>When Scanned Outside Think5Whys:</strong> {caesarCipher(donaQR.donaQRText, donaQR.donaqrEncryptionKey)}
                      </p>
                    )}
                    <br />
                    <p><strong>Donors List:</strong></p>
                    <div className="overflow-x-auto">
                      <table className="table-auto min-w-full">
                        <thead className="bg-gray-500 text-white">
                          <tr>
                            <th className="px-4 py-2 text-left" colSpan="2">Donor</th>
                            <th className="px-4 py-2 text-left" colSpan="2">Contact</th>
                            <th className="px-4 py-2 text-left" colSpan="2">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(donaQR.donaqrDonors) && donaQR.donaqrDonors.map((donor, index) => (
                            <React.Fragment key={index}>
                              <tr key={index} className="text-blue-800 align-text-top">
                                <td className="border px-4 py-2" colSpan="2">
                                  {donor.name}
                                </td>
                                <td className="border px-4 py-2" colSpan="2">
                                  {donor.city} | {donor.mobileNumber} | {donor.emailID}
                                </td>
                                <td className="border px-4 py-2" colSpan="2">
                                  <strong>{donor.donationAmount.toFixed(2)}</strong><br />
                                  {formatDateTime(donor.donationDate)}<br />
                                  {donor.receiptNumber}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                          <tr className="bg-gray-500 text-white">
                            <td className="border px-4 py-2" colSpan="4">Total Donation Amount:</td>
                            {/* <td className="border px-4 py-2" colSpan="2">{calculateTotalAmount(donaQR.donaqrDonors)}</td> */}
                            <td className="border px-4 py-2" colSpan="2"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <p><strong>Remittances:</strong></p>
                    {Array.isArray(donaQR.donaqrRemittances) && donaQR.donaqrRemittances.map((remittance, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Date:</strong> {remittance.remitDate}</p>
                        <p><strong>Period Start Date:</strong> {remittance.remitPeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {remittance.remitPeriodEndDate}</p>
                        <p><strong>Amount:</strong> {remittance.remitAmount}</p>
                        <p><strong>Remarks:</strong> {remittance.remitRemarks}</p>
                      </div>
                    ))}
                    <br />
                    <p><strong>Incentive Payments:</strong></p>
                    {Array.isArray(donaQR.donaqrIncentivePayments) && donaQR.donaqrIncentivePayments.map((payment, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Pay Date:</strong> {payment.incentivePayDate}</p>
                        <p><strong>Period Start Date:</strong> {payment.incentivePeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {payment.incentivePeriodEndDate}</p>
                        <p><strong>Amount:</strong> {payment.incentiveAmount}</p>
                        <p><strong>Remarks:</strong> {payment.incentiveRemarks}</p>
                      </div>
                    ))}
                    <br />
                    <p><strong>Tax Details:</strong></p>
                    {donaQR.donaqrTaxDetails.map((taxDetail, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Type:</strong> {taxDetail.taxType}</p>
                        <p><strong>Pay Date:</strong> {taxDetail.taxPayDate}</p>
                        <p><strong>Period Start Date:</strong> {taxDetail.taxPeriodStartDate}</p>
                        <p><strong>Period End Date:</strong> {taxDetail.taxPeriodEndDate}</p>
                        <p><strong>Amount:</strong> {taxDetail.taxAmount}</p>
                        <p><strong>Remarks:</strong> {taxDetail.taxRemarks}</p>
                        <p><strong>Deductor Account Number:</strong> {taxDetail.deductorAccount}</p>
                        <p><strong>Depositor Account Number:</strong> {taxDetail.depositorAccount}</p>
                      </div>
                    ))}
                    <br />
                    <p><strong>QR Code Generation:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Cost:</strong> {donaQR.donaqrGenCost}</p>
                      <p><strong>Cost Type:</strong> {donaQR.donaqrGenCostType}</p>
                      <p><strong>Cost Currency:</strong> {donaQR.donaqrGenCostCurrency}</p>
                    </div>
                    <p><strong>QR Code Scan:</strong></p>
                    <div className="ml-8 text-blue-800">
                      <p><strong>Cost:</strong> {donaQR.donaqrScanCost}</p>
                      <p><strong>Cost Type:</strong> {donaQR.donaqrScanCostType}</p>
                      <p><strong>Cost Currency:</strong> {donaQR.donaqrScanCostCurrency}</p>
                    </div>
                    <br />
                    <p><strong>Advertisers:</strong></p>
                    <div className="overflow-x-auto">
                      <table className="table-auto w-full">
                        <thead className="bg-gray-500 text-white align-text-top">
                          <tr>
                            <th className="px-4 py-0 text-left">Name</th>
                            <th className="px-4 py-0 text-left">Message</th>
                            <th className="px-4 py-0 text-left">Active</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(donaQR.donaqrAdvertisers) && donaQR.donaqrAdvertisers.map((advertiser, index) => (
                            <tr key={index} className="text-blue-800">
                              <td className="border px-4 py-0">{advertiser.advertiserName}</td>
                              <td className="border px-4 py-0">{advertiser.advertiserMessage}</td>
                              <td className="border px-4 py-0">{advertiser.advertiserIsActive ? 'Yes' : 'No'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <p><strong>Accessors:</strong></p>
                    <div key="accessors" className="ml-8 text-blue-800">
                      {donaQR.donaqrAccessors.map(accessor => accessor.accessorName).join(', ')}
                    </div>
                    <p><strong>Partner:</strong></p>
                    {Array.isArray(donaQR.donaqrPartner) && donaQR.donaqrPartner.map((partner, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p><strong>Name:</strong> {partner.partnerName}</p>
                      </div>
                    ))}
                    <p><strong>Access Dates:</strong></p>
                    {Array.isArray(donaQR.donaqrDetailsAccessDate) && donaQR.donaqrDetailsAccessDate.map((accessdate, index) => (
                      <div key={index} className="ml-8 text-blue-800">
                        <p>{formatDateTime(accessdate.accessDateTime)}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      {/* </>
      )} */}
    </div>
  );
};

export default DonaQRMyQRs;
